var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isEmpty)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"md12":""}},[(this.verified)?_c('m-onboard-story',{attrs:{"item":_vm.onboarding[_vm.index]},on:{"skip":_vm.skip,"dismiss":_vm.dismiss}}):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }